// `accent` picks each category's color from the Powerpuff Girls palette:
// #FF3E8E pink, #4FC9FF blue, #8CE04A green, #FFD93D yellow, #C9A6FF lavender.

export const Skills = [
  {
    id: 1,
    title: 'Languages',
    accent: '#FF3E8E',
    items: ['Python', 'JavaScript', 'TypeScript', 'Java', 'C#', 'C/C++'],
  },
  {
    id: 2,
    title: 'Frameworks',
    accent: '#4FC9FF',
    items: ['React', 'Redux', 'Spring Boot', 'React Native', 'Expo', 'ASP.NET', 'Node.js'],
  },
  {
    id: 3,
    title: 'Databases',
    accent: '#8CE04A',
    items: ['PostgreSQL', 'MySQL', 'MongoDB', 'Supabase'],
  },
  {
    id: 4,
    title: 'Cloud & Platforms',
    accent: '#FFD93D',
    items: ['GCP', 'Docker', 'Jenkins', 'Webpack'],
  },
  {
    id: 5,
    title: 'AI-Assisted Development',
    accent: '#C9A6FF',
    items: ['GitHub Copilot', 'Claude Code'],
  },
]
